<template>
  <vs-wrapper>
    <vs-heading>
      <v-alert v-show="!activeFieldDefinition" border="left" color="orange" text type="info">
        No field selected.<br />
        Select a field to edit it here.
      </v-alert>
    </vs-heading>

    <core-field-settings
      v-if="activeFieldDefinition"
      :field="activeFieldDefinition"
      :is-editing-custom-fields="isEditingCustomFields"
      :is-required-toggle-visible="false"
      class="mb-3"
      @modify-field="modifyField"
      @remove-field="removeField"
    ></core-field-settings>

    <specific-field-settings
      v-if="activeFieldDefinition"
      :field="activeFieldDefinition"
      :field-type-name="fieldTypeName"
      @modify-field="modifyField"
      @remove-field="removeField"
    />
  </vs-wrapper>
</template>

<script>
import RelationshipsEditor from '@/components/form-builder/RelationshipsEditor'
import CoreFieldSettings from '@/components/form-builder/field-settings/CoreFieldSettings'
import SpecificFieldSettings from '@/components/form-builder/field-settings/SpecificFieldSettings'
import VsWrapper from '@/components/vision/VsWrapper'
import VsHeading from '@/components/vision/VsHeading'

export default {
  name: 'FieldTemplatesEditor',
  components: {
    VsHeading,
    VsWrapper,
    SpecificFieldSettings,
    CoreFieldSettings,
    RelationshipsEditor,
  },

  props: {
    fieldTypeName: {
      type: String,
      default: '',
    },
    activeFieldDefinition: {
      type: Object,
      default: null,
    },
    activeFlow: {
      type: String,
      default: '#root_schema',
    },
    referenceFields: {
      type: Array,
      default: () => {},
    },
    isEditingCustomFields: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    modifyField(data) {
      this.$emit('modify-template', data)
    },
    removeField(field) {
      this.$emit('remove-template', field)
    },
  },
}
</script>

<style scoped></style>
